import { Component, inject } from '@angular/core';
import { IonIcon } from '@ionic/angular';
import { Store } from '@ngrx/store';

import {
  BtnComponent,
  CompanySelectorMenuComponent,
  HomePageToolbarComponent,
  NtyEmptyStateModule,
  PageComponent,
  UserMenuComponent,
} from '@ninety/mobile/platform/components';
import { appActions, SessionActions } from '@ninety/mobile/platform/state';

@Component({
  selector: 'nty-no-access',
  imports: [
    BtnComponent,
    CompanySelectorMenuComponent,
    HomePageToolbarComponent,
    NtyEmptyStateModule,
    PageComponent,
    UserMenuComponent,
    IonIcon,
  ],
  template: `
    <nty-page class="no-access" [id]="contentId">
      <nty-home-page-toolbar nty-header />

      <nty-empty-state>
        <nty-empty-state-graphic>
          <!-- Temporary Graphic - replace when new graphic is chosen -->
          <ion-icon src="assets/icons/mountains--duotone.svg" />
        </nty-empty-state-graphic>
        <nty-empty-state-title>Your account has expired.</nty-empty-state-title>
        <nty-empty-state-description>Please sign in to our web app to renew.</nty-empty-state-description>
        <nty-empty-state-btn (click)="renew()">Renew</nty-empty-state-btn>
        <nty-btn class="sign-out" type="outline" (click)="signOut()">Sign Out</nty-btn>
      </nty-empty-state>
    </nty-page>
    <nty-company-selector-menu [contentId]="contentId" />
    <nty-user-menu [contentId]="contentId" />
  `,
  styles: `
    nty-empty-state {
      max-width: 480px;
      margin: 0 auto;
      padding: 24px;
    }

    .sign-out {
      align-self: center;
    }
  `,
})
export class NoAccessComponent {
  store = inject(Store);
  contentId = 'no-access-content';

  signOut() {
    this.store.dispatch(SessionActions.eventReceived({ event: { type: 'signOutRequested' } }));
  }

  renew() {
    this.store.dispatch(appActions.openDesktopApp({}));
  }
}
